import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/packge_tag/free.png')
const LOGO = assets.images.packgeTag.free

const FreePackageTag = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default FreePackageTag
